module.exports = {
  common: {
    all: "All",
    searchPlaceholder: "Searching in 7-Eleven",
    recentlySearched: "Search history",
    hotKeywords: "Hot Keywords",
    clearAll: "Clear All",
    language: "language",
    register: "Sign up",
    login: "Log in",
    home: "Home",
    searchResult: "Search Result",
    wellcome: "7-Eleven",
    filter: " filter",
    sortBy: "Sort By",
    recommended: "Recommended",
    topSales: "Top Sales",
    price: "Price",
    brand: "Brand",
    showResult: "Show result",
    show: "Show",
    result: "result",
    results: "results",
    lowestFirst: "Lowest First",
    highestFirst: "Highest First",
    addToCart: "Add to Cart",
    previous: "Previous",
    next: "Next",
    goToPage: "Go to Page",
    go: "Go",
    soldOut: "Unavailable",
    showMore: "Show More",
    showLess: "Show Less",
    allCategories: "All Categories",
    account: "My Account",
    addresses: "Addresses",
    myCards: "My Cards",
    myCoupons: "My Coupons",
    myAddresses: "My Addresses",
    myOrders: "My Orders",
    accountSetting: "Account Setting",
    logout: "Logout",
    point: "Points",
    worth: "Worth",
    confirm: "Confirm",
    cancle: "Cancle",
    logOutTips: "Logout Reminder",
    logOutMsg: "Are you sure you want to logout? ",
    logoutSuccess: "Logout successfully",
    freeDeliveryAbove: "Get free delivery above <span class='free'>{amount}</span>",
    freeDeliveryMore: "<span class='free'>{amount}</span> more to get free delivery",
    freeDeliveryGet: "Great! You get free delivery!",
    viewAll: "View All",
    findSimilar: "Similar products",
    similarProducts: "Similar Products",
    loginAndregister: "Sign up | Log in",
    signUpSuccess: "Sign up successfully",
    loginInSuccess: "Log in successfully",
    selectDeliveryAddress: "select Delivery Address",
    orderList: "My Orders",
    collectOrderNotice: "Add more item(s) below to cart and enjoy the offer",
    orderDetails: "Order Details",
    searchResults: "{searchResult} results",
    multipleOffers: "Multiple offers",
    loginExpired: "Login is expired, please login again if you want to continue your operation",
    checkYourAddress: "Check your address before shopping",
    checkYourAddressTips:
      " Your delivery address will affect product availability. To ensure a smooth checkout process, please check that this is the address you're shopping for. Click address above to change.",
    ok: "ok",
    deliverTo: "Deliver to",
    noAdress: "No saved address found",
    addAddress: "Add address",
    addDeliveryAddress: "Add delivery address",
    default: "Default",
    similarLikeTitle: "Similar products you might like:",
    categories: "Categories",
    noAddressPopTitle: "Where should we deliver to?",
    noAddressPopContent: "Please provide your delivery address so we can offer you the best shopping experience",
    backToBrowse: "Back to browse",
    addNewAdd: "Add Address",
    unavaliableDeliveryAddressTips:
      "Sorry,we are currently unavaliable to provide our services to your delivery address,",
    changeDeliveryAddressTips: "please try to change your delivery address or wait for our further update.",
    thankYouTips: "Thank you for your support!",
    yes: "YES",
    no: "NO",
    logoutfailed: "Logout failed",
    customer: "Customer Care",
    followUs: "Follow us on",
    wellCenter: "7-Eleven Help Center",
    storeLocator: "Store Locator",
    ourStory: "Our Story",
    corporateResponsibility: "Corporate responsibility",
    corporatePromotions: "Corporate promotions",
    contactUs: "Contact us",
    careers: "Careers",
    termsAndConditions: "Terms and conditions",
    restrictedFoodPermits: "Restricted Food Permits",
    feedback: "Give Feedback",
    shareWithCopyText: "Copied",
    share: "Share",
    bestMatches: "Best Matches",
    comingSoon: "Coming Soon",
    notification: "Notification setting",
    linkYuuTips: "Link your yuu Account to enjoy amazing yuu offers and exclusive experience of 7-Eleven.",
    myProfile: "Personal info",
    quickStartGuide: "Pre-order Quick Start Guide​"
  },
  category: {
    result: "results",
    category: "Category",
    name: "Categories",
    noResult: "We cannot find any items match your filter criteria, please modify and try again.",
    search: "Search ",
    noResults: "No Results",
    all: "All"
  },
  search: {
    noResultTip:
      "Sorry, we can't find <span class='highlight'>\"{keyword}\"</span> product(s). We recommended relevant items for you:",
    resultTip: "{count} items found for <span class='highlight'>\"{keyword}\"</span>"
  },
  footer: {
    download: "Great deals at your fingertips. Download now!",
    faq: "FAQs",
    contact: "Contact Us",
    email: "Email",
    payment: "Payment Methods",
    terms: "E-Comm Service Terms and Conditions",
    privacy: "Privacy Policy",
    dfi: "DFI Retail Group",
    storeLocator: "Store Locator",
    ourStory: "Our Story",
    corporateResponsibility: "Corporate Responsibility",
    corporatePromotions: "Corporate Promotions",
    careers: "Careers",
    restrictedFoodPermits: "Restricted Food Permits",
    officeHours: "Office Hours",
    followUs: "Follow us on",
    officeHoursValue: "Mon-Fri: 09:00-17:00 (Except Public Holidays)",
    wellcomeWhatsAppTermsAndConditions: "7-Eleven WhatsApp Terms and Conditions"
  },
  cms: {
    addToCart: "Add to Cart",
    findSimilar: "Similar products",
    soldOut: "Unavailable",
    viewAll: "View All"
  },
  productDetails: {
    productDetails: "Product Details",
    youMightAlsoLike: "You might also like",
    freshnessTitle: "Freshness Information",
    freshnessInfo: "7-Eleven promises this item will stay fresh for {num} days, including the day of delivery.",
    size: "Size",
    storage: "Storage",
    freshness: "Freshness",
    country: "Country",
    offers: "Offers",
    description: "Description",
    ProductDetail: "Product detail",
    redemption: "Redemption",
    gift: "Gift",
    origin: "Origin",
    preOrderPeriod: "Pre-order period",
    pickupPeriod: "Pick-up Period",
    DeliveryPeriod: "Delivery Period",
    itemCode: "Item code:",
    sameBrand: "Same brand",
    notAvailable: "Not Available",
    notAvailableTips:
      "This item are unavailable for purchase in selected pick up store. Please switch to another store that supports these items.",
    addCartSuccessful: "Added to Cart Successfully",
    limitPurchased: "Sorry, this item has a purchase limit of {purchaseLimit} pieces.",
    offlinePaymentTips:
      "This item is eligible for offline payment only. Please complete your payment at any store within 24 hours after successfully placing your order."
  },
  paymentSuccessful: {
    tips: "Payment status update may be delayed by about 3-5 minutes due to bank processing. Thank you",
    paymentSuccessful: "Payment Succesful!",
    expectedDeliveryDateAndTime: "Expected Delivery Date and Time:",
    expectedPickupDateAndTime: "Expected Pick up Date and Time:",
    continueShopping: "Continue Shopping",
    viewOrder: "View Order",
    pickUpDate: "Pick up in {date} days"
  },
  pendingPayment: {
    pendingPayment: "Pending Payment",
    tips: "Payment will be processed in Hong Kong Dollars (HK$)",
    with: " with enJoy Card",
    saved: "Saved",
    payFail: "Payment Error Detected"
  },
  order: {
    all: "All",
    hideDetails: "Hide Details",
    showDetails: "Show Details",
    lastThreeMonths: "Orders of last 3 months",
    threeMonthsAgo: "Orders of 3 months ago",
    ordersFromWebsite: "Orders from Website",
    pleaseSelect: "Please select",
    goToAppTips: "Please go to our 7-Eleven app and check more details",
    total: "Total",
    pieces: "pieces",
    orderPlaced: "Order placed:",
    delivery: "Delivery",
    pickup: "Pick up",
    parentOrderNo: "Parent Order No:",
    orderNo: "Order No:",
    noAppOrder: "You have not placed any order yet",
    noWebOrder: "You have not placed any order yet",
    noWebOrderProcess: "You don't have processing orders",
    noWebOrderComplete: "You don't have complete orders",
    startShopping: "Start Shopping",
    my: "My",
    order: "Order",
    banner:
      "All orders are synced from the 7-Eleven app. Some orders might be split, but we will deliver them together for each purchase.",
    syncedOrder: "Current order is synced from 7-Eleven app.",
    gift: "Gift",
    redeemed: "Redeemed",
    download: "Download",
    processing: "Processing",
    completed: "Completed",
    loadingText: "Loading...",
    finishedText: "No more data",
    pickUpAt: "Pickup at:",
    pickUpPeriod: "Pick up period:",
    deliveryPeriod: "Delivery Period:",
    deliveryTime: "Delivery Time:",
    qrCode: "QR code",
    offlineOrderNumber: "Order No.:",
    offlinePaymentQrCode: "Payment QR Code",
    offlinePaymentQrTips: "Please complete payment at store.",
    offlinePaymentTime: "Time left to pay",
    orderCancelled: "Order cancelled",
    orderCancelledTips: "Order cancelled due to payment timeout.",
    orderBtnTxt: "OK",
    copy: "Copy",
    feedbackText: "Have a minute? Tell us how we can improve",
    submitFeedBack: "Submit FeedBack",
    showQRtoCashier: "Please show the QR code to cashier",
    pickUpNumber: "Pick up number",
    orderNumber: "Order number"
  },
  orderDetails: {
    orderNo: "Order number:",
    checkSignature: "Check signature",
    eReceipt: "E-receipt",
    deleteOrder: "Delete Order",
    deleteOrderTips: "Are you sure you want to delete the order?",
    cancel: "Cancel",
    buyAgain: "Buy Again",
    stayHere: "Stay here",
    goToCart: "Go to cart",
    copySuccess: "Copy successfully",
    deleteOrderSuccess: "Order is deleted",
    cancelOrderSuccess: "Order is cancelled",
    reason: "Please select a Reason",
    totalItems: "Total {totalCount} Item(s)",
    freeGifts: "Free gifts",
    free: "Free",
    orderInfo: "Order information",
    orderSummary: "Order summary",
    saved: "Saved",
    total: "Total",
    relatedOrderNo: "Related Order No:",
    cancelReason: "Cancel Reason",
    reasonPlaceholder: "Please select a reason",
    confirm: "Confirm",
    cancelOrder: "Cancel Order",
    cancelAll: "Cancel All",
    quantity: "QTY",
    productdisabledTitle: "View item details with 7-Eleven app",
    outOfStock: "Out of stock",
    ordersFromDifferentStores:
      "This order contains multiple orders from different stores, please click 'Confirm' to cancel the entire order.",
    confirmO: "Confirm",
    pendingPaymentTips:
      "This order contains multiple orders from different stores, please click continue to proceed the checkout.",
    confirmP: "Continue",
    contactOurDeliveryMan: "Contact our delivery staff",
    orderTracking: "Order Tracking",
    deliveryAddress: "Delivery details:",
    deliveryTime: "Delivery period:",
    saverStamps: "SaverStamps earned",
    funStamps: "FunStamps earned",
    stampView: "Press 'View' to check more details",
    view: "View",
    stampPopupDesc:
      "The number of stamps earned is calculated based on the total amount of associated Fresh orders listed below.",
    vendorInfoTitle: "Vendor Information"
  },
  dshop: {
    activityNotStarted: "This promotion event has not started yet, please come again later({code})",
    activityOver: "This promotion event has ended, thank you for your support({code})",
    activityRegionNotMatch:
      "Unfortunately this campaign is not available for the store you picked. Please select another store.",
    activitySorryWrong: "Sorry, the network is unstable, please retry({code})",
    retry: "Retry",
    goToHomepage: "Back to homepage",
    allCategories: "All {num} categories",
    storeIsNotAvailable: "Store is not available"
  },
  cart: {
    my: "My",
    myCart: "My Cart",
    selectAll: "Select All",
    remove: "Remove",
    addMore: "Add more",
    deliverTo: "Deliver to",
    change: "Change",
    edit: "Edit",
    coupons: "Coupons",
    applied: "applied",
    available: "available",
    total: "Total",
    totleSaved: "Saved",
    saved: "Saved",
    checkout: "Checkout ({count})",
    removeTitle: "Remove from the cart",
    removeMessage: "Are you sure you want to remove these item(s) ?",
    cancel: "Cancel",
    addressChangedTips: "Your basket has been updated to reflect available items",
    stockTips: "Only {stock} unit(s) left",
    maximumStockTips: "The quantity of selected item has reached the maximum stock",
    rangeNotNearestTitle:
      "The following items have been added for a different delivery region or delivery method. Please change your address or delivery mode to recover them",
    rangeStandardDeliveryTitle:
      "The following items cannot be delivered to you, please enjoy the full shopping experience in our 7-Eleven app",
    unRangeStoreGroupTitle:
      'The following items cannot be delivered to you with "Express" or "Pre-Order" store in the website yet, please enjoy the full shopping experience in our 7-Eleven app',
    deliveryAndPackagingFee: "Including delivery fee ${deliveryFee} + packaging handling fee ${packagingFee}",
    onlyDeliveryFee: "Including delivery fee ${deliveryFee}",
    onlyPackagingFee: "Including packaging handling fee ${packagingFee}",
    handlingAndPackagingFee:
      "Including Click & Collect Handling Fee ${handlingFee} + packaging handling fee ${packagingFee}",
    onlyHandlingFee: "Including Click & Collect Handling Fee ${handlingFee}",
    saveMoreOffersTitle: "Save more with our offers",
    viewMore: "View more",
    viewLess: "View less",
    emptyText: "Your shopping cart is empty",
    continueShopping: "Continue Shopping",
    freeGifts: "Free gifts",
    soldout: "Unavailable",
    free: "Free",
    unavailableWaresTitle:
      "Your basket may have been changed due to a change in delivery region or delivery method. View the removed items below",
    findSimilar: "Find similar",
    editRecipient: "Edit Recipient",
    mandatoryFields: "* mandatory field(s)",
    recipientName: "Recipient Name*",
    recipientMobileNumber: "Recipient Mobile Number*",
    emailMessae: "Please confirm if the email address is correct.",
    emailDescription: "This email address is only used for receiving order updates.",
    emailShow: "Please fill in recipient information",
    emailEnter: "Please enter email address",
    email: "Email*",
    recipientWarningTextWith11Digits: " Enter a valid phone number with 11 digits",
    recipientWarningTextWith8Digits: " Enter a valid phone number with 8 digits",
    save: "Save",
    myAddresses: "My Addresses",
    select: "Select",
    giftSelectMsg: "Select {maxGiftQty} free gift(s)",
    changedGiftOrTradeMsg: "Your Gift(s)/Redeem Offer Updated",
    changedGiftOrTradeMinorMsg: "Your gift/redemption items have been updated due to changes in purchase quantity.",
    redeemFreeMsg: "Redeem selected items for Free",
    redeemVerticalReductionMsg: "Redeem selected items and Save ${value}",
    redeemDiscountMsg: "Redeem selected items and Get {value}% off",
    redeemSpecialOfferMsg: "Redeem selected items for ${value}",
    slaveStoreMsg: "Seamlessly check out items from other stores synced with your 7-Eleven app on the 7-Eleven website",
    slaveStoreTip: "View item details with 7-Eleven app",
    RedeemNow: "Redeem now",
    GoBack: "Go Back",
    pickUpAt: "Pick up at:",
    deliveryOnlyDesc: "{count} items are available for home delivery only",
    seeItems: "See items",
    deliveryOnlyTitle: "The following items are only available for home delivery",
    reminder: "Reminder",
    giftMessage:
      "You have forgot or haven't added enough free gift item(s) to your cart, do you still want to continue checkout?",
    no: "No",
    yesContinue: "Yes, Continue",
    giftNotEnough: "Sorry, inventory is not enough",
    allGiftOutOfStock: "All free gift items are unavailable",
    pleaseEnterPickupName: "Please input the pickup person's name",
    separateOrderDesc: "We will divide the items into separate orders due to the varying pickup periods.",
    pickAt: "Pick up at",
    shopTips:
      " items are unavailable for purchase in selected pick up store. Please switch to another store that supports these items.",
    done: "Done",
    UnavailableGoods: "Unavailable Items",
    delete: "Delete",
    salesAreaHK: "HK only",
    salesAreaMacao: "MO only",
    designatedStore: "Selected stores",
    salesAreaHKPickUp: "Hong Kong pickup only",
    salesAreaMacaoPickUp: "Macao Kong pickup only",
    salesAreaOnlyHKPickUp: "HK",
    salesAreaOnlyMacaoPickUp: "MO",
    cart_pick_up: "Pick up",
    cart_delivery: "Delivery",
    deliveryMethod: "Delivery Method",
    pleaseAddAnAddress: "Please Add An Address",
    addAddress: "Add",
    myAddress: "My Address",
    selectDeliveryAddress: "Select Delivery Address",
    SelectableAtCheckout: "(Choose delivery date at checkout)",
    preOrderPickUp: "Pre-order Pickup",
    preOrderDDelivery: "Pre-order Delivery",
    removeAddressTitle: "Confirm removal of this address?",
    removeAddressCancel: "Cancel ",
    removeAddressConfirm: "Yes "
  },
  coupon: {
    myCoupons: "My Coupons",
    emptyText: "You don't have any coupons yet",
    usageRules: "Usage rules",
    valid: "Valid",
    invalid: "Invalid",
    reedem: "Redeem",
    reedemMessage: "Your coupon has been successfully redeemed!",
    daysLeft: "{count} day(s) left",
    effectivePeriod: "Effective Period",
    applicableFor: "Applicable for",
    coupons: "Coupon(s)",
    apply: "Apply",
    applySuccessMessage: "Your coupon has been successfully applied!",
    applyInapplicableMessage:
      "Sorry, this coupon is not applicable to the current order.Please double check its usage conditions.",
    chosenSavedText: "You have chosen {length} coupon(s), and Saved",
    applicable: "Applicable",
    inapplicable: "Inapplicable",
    enterPlaceholder: "Enter your coupon code here",
    EGiftVoucher: "Online Shop Voucher",
    ECoupon: "E-Coupon",
    combinedText: "Can be combined with other coupon"
  },
  checkout: {
    isFull: "已满",
    deliveryTipsTitle: "The delivery team will contact you before delivery to confirm. ",
    deliveryTipsContent:
      "Extra charges may apply for remote areas – please check product delivery details before ordering.",
    QTY: "QTY",
    paymentTips: "We current only accept credit card payments on our website.",
    and: "and",
    mark1: "Please call me before delivery",
    mark2: "Please leave the goods at door",
    markAny: "Please fill other instructions here if any",
    save: "save",
    headerTitle: "Secure Checkout",
    deliverTo: "Deliver to",
    edit: "Edit",
    addDeliveryIns: "Add Delivery Instruction",
    deliveryIns: "Delivery Instruction",
    deliverTime: "Deliver Time",
    pleaseSelect: "Please Select",
    noAvailable: "No available delivery slot",
    coupons: "Coupons",
    available: "available",
    applied: "applied",
    paymentMethod: "Payment Method",
    cardTips: "We current only accept credit card (Visa and MasterCard only) payments on our website.",
    cardTips2:
      "A temporary charge of HK$0.10 may appear in your transaction history to verify that your card is open and in good standing. Upon verification, the HK$0.10 will be released.",
    promotionTips:
      "Save 8% on your purchases of $100 or more (net spending) at 7-Eleven & Market Place with Hang Seng enJoy Card today.",
    addNewCard: "Add New Credit Card",
    bindNewCardAndPay: "Bind a new card and pay",
    orderReview: "Order Review",
    DSecureAuth: "3-D Secure Auth",
    add: "Add",
    change: "Change",
    select: "Select",
    next: "Next",
    payNow: "Pay & Verify",
    cardVeri: "Credit Card Verification",
    mandatoryFileds: "mandatory field(s)",
    cardNumber: "Card number",
    creditCardNumber: "Your Credit Card number",
    expiryDate: "Expiry Date (month/year)",
    mm: "MM",
    yy: "YY",
    digits: "3 digits on the back of card",
    cardholderName: "Cardholder's name",
    nameOnCard: "Your name on the card",
    saveTips: "Save credit card as default for next purchase",
    saveTips2: "I acknowledge that my card information is saved in my account for future transactions",
    showDetails: "Show Details",
    hideDetails: "Hide Details",
    total: "Total",
    total2: "Total",
    item: "Item(s)",
    orderSummary: "Order Summary",
    infoTips: "Pre-order products are available while stocks last. No refund nor exchange for pre-ordered product.",
    pay: "Pay",
    saved: "Saved",
    summaryTips1: 'Clicking "Pay" confirm that I agree to the',
    summaryTips5: 'Clicking "Total" confirm that I agree to the',
    summaryTips2: "will apply to this transaction.",
    summaryTips3: "<span style='font-weight: bold;'>Payment cannot be cancelled or refunded after confirmation.</span>",
    errorTips: "error status",
    bindCardSuccess: "bind card success",
    Including: "Including ",
    deliveryFee: "delivery fee",
    packagingHandlingFee: "packaging handling fee",
    week: ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"],
    month: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "July", "Aug", "Sept", "Oct", "Nov", "Dec"],
    format: "en",
    freeGifts: "Free gifts",
    free: "Free",
    note: "Note",
    backToCart: "Back to Cart",
    pendingPayment: "Pending Payment",
    notice: "Notice",
    text: "For standard products ordered, you cannot cancel such order once we have commenced/confirmed packing, picking or delivery of the products to you. For any special items ordered, no cancellation is possible after payment confirmation.",
    tipsCancel: "Under 18",
    tipsConfirm: "18 or above",
    noCardTips: "Select your payment method",
    payAnyway: "Pay Anyway",
    error: {
      cardNumber: "Please use a Visa or MasterCard credit card, or check if the card number is correct",
      expiryDate: "Incorrect expiry date",
      securityCode: "CVV invalid or missing"
    },
    systemError: "You stayed on this page too long, please enter this page again.",
    homeDelivery: "Home Delivery",
    clickCollect: "Click & Collect",
    pickAt: "Pick up at:",
    noTimeTips: "Please select delivery time",
    recommended: "Recommended",
    continueWithThisSlot: "Continue with this slot",
    unableTips: "Deselecting items may change the promotions and freebies options. Delivery fee may also apply.",
    viewCart: "View in my cart",
    processCheckout: "Proceed to check out",
    unavailableItems: "Unavailable items",
    unavailableItemsWarn:
      "If you proceed with this time slot, the item mentioned below will not be included in your payment but will remain in your cart.",
    unavailableItemsText:
      "By continue with this slot you will have changes on  promotions, freebie, or redemptions item.",
    redeemed: "redeemed",
    gift: "Gift",
    full: "Full",
    deliveryFee2: "Delivery fee:",
    deliveryDateTitle: "Change Delivery Date",
    deliveryDateContent: "Choose your preferred delivery date",
    gotIt: "Got it",
    offlinePayment: "Pay at Store",
    placeOrder: "Total:",
    placeOrderSuccess: "Order Submitted (Payment Pending)",
    offlinePaymentStoreTips: "Please complete payment at any store within 24 hours to finalize your order.",
    qrCodeCashier: "Payment QR Code",
    offlineViewOrder: "View Order Details",
    chooseDeliveryDate: "Choose delivery date",
    deliveryDescribe: "We’ll be in touch before delivery.",
    deliveryTime: "Delivery Time",
    pleaseselect: "Please select",
    beforeDelivery: "We’ll be in touch before delivery.",
    paymentReminder: "Please select a payment method and a timeslot to continue with your order.",
    selectPayMethod: "Select payment method",
    titleTips: "We current only accept credit card payments on our website.",
    plsSelectTips: "Please select the payment method",
    addCardTipsTitle: "Add new credit card",
    addCardTipsContent: "You will be required to enter card information on the next page."
  },
  card: {
    myCards: "My Cards",
    add: "Add New Card",
    deleteCard: "Delete Credit Card",
    confirmText: "Are you sure you want to delete this credit card from your account? ",
    cancel: "No",
    confirm: "Delete",
    message: "Successfully unbinding",
    expiredTips: "Your credit card has expired"
  },
  pageTitle: {
    cart: "My Cart",
    checkout: "Secure Checkout",
    cards: "My Cards",
    coupons: "My Coupons",
    order_list: "My Orders",
    order_details: "Order Details",
    cashier: "Checkout Cashier",
    payment: "Payment Successful",
    categoryName: "{name}",
    storeLocator: "Store Locator",
    notification: "Notification settings",
    loginOrRegister: "Login / Register"
  },
  getTheApp: {
    title: "7-Eleven mobile is better on the 7-Eleven app ",
    description: "For an optimized mobile experience, shop in 7-Eleven online shop now!",
    goTo: "Go to 7-Eleven",
    notNow: "Not now"
  },
  page: {
    title: "7-Eleven online shop",
    description:
      "The 7-Eleven Pre-order Online Shop is now open! Enjoy one-stop shopping, exclusive launch discounts, and pre-order amazing items with just one click!"
  },
  error: {
    pageNotFound: "Page Not Found",
    serverError: "Server Error",
    backHome: "Go to homepage",
    notFound: "404 - PAGE NOT FOUND",
    notFoundTips: "The page you are looking for might have removed",
    internalServerError: "500 - INTERNAL SERVER ERROR",
    internalServerErrorTips: "Sorry, the server is temporarily unavailable. Please try again later."
  },
  collect: {
    bestOfferTitle: "SmartSaver",
    bestOfferText1: "Offer(s) available",
    bestOfferText2: "Add more item(s) to enjoy our offer(s)",
    selectNum: "Select {num} item(s)",
    completed: "Completed",
    showMore: "Show more",
    collapse: "Collapse",
    unavailable: "unavailable"
  },
  auth: {
    phoneNumber: "Phone number",
    login: "Login",
    signUp: "Sign up",
    changePwd: "Change Password",
    forgotPwd: "Forgot your password?",
    smsCode: "SMS Code",
    enterPhoneNumber: "Phone number",
    enterYourPwd: "Enter your password",
    password: "Password",
    setNewPassword: "Set New Password",
    submit: "Submit",
    or: "OR",
    loginWithSMS: "Login with SMS",
    loginWithPwd: "Login with password",
    connectWith: "Connect with",
    register: "Register",
    noAccount: "No account?",
    SMSVerification: "SMS Verification",
    sendSMS: "Send Code",
    alreadyHaveAccount: "Already have an account?",
    protocal1: "(i) you have read and agreed to the",
    termsAndConditions: "Terms & Conditions",
    PICS: "PICS",
    and: "and",
    privacyPolicy: "Privacy Policy",
    protocal2: "DFI (which owns and operates this Website) would like to use your personal data for",
    directMarketingPurposes: "Direct Marketing purposes",
    protocal3: "as stated in the above",
    checkTip: "Please tick this box if you do not wish DFI to do this.  ",
    comma: ",",
    period: ".",
    // login modal
    createANewAccount: "Create a new account?",
    createAccount: "Create Account",
    createAccountContent:
      "Your current phone number is not a registered account for 7-Eleven. Please create account or enter another login information",
    enterSMSCode: "Please enter the verification code",
    enterYourPassword: "Please enter the password",
    enterYourNewPassword: "Please enter your new password",
    invalidPhoneNumber: "Please enter a valid phone number",
    termsAndConditionsRequired: "Please agree to the terms and conditions",
    // sign up modal
    loginWithYourAccount: "Login with your account?",
    registeredAccount:
      "This is a registered phone number. Please return to login page and enter your password or SMS code",
    // create password modal
    skip: "Skip",
    createPassword: "Create passsword for your account?",
    reconfirmPassword: "Reconfirm Password",
    repeatYourPassword: "Repeat your password",
    resetPasswordSuccess: "Password changed successfully",
    passwordRule: "Please enter a password with 6-16 characters",
    signUpTips: "For new sign up, a 7-Eleven account will be automatically created after verification.",
    loginOrRegister: "Login / Register",
    loginOrRegisterTips: "with yuu account to store points.",
    loginNextTips: "By clicking “Next”, you confirm that:",
    protocalNewRegistration:
      "(ii) For new registration, a 7-Eleven account will be automatically created after verification.",
    verificationPageTips: "Enter the verification code sent to {phone} to continue.",
    EnterVerificationCode: "Enter verification code",
    continueWithAsYuuMember: "Continue with as yuu member",
    yuuTips1: "To earn yuu points, enjoy amazing yuu offers and exclusice offer of 7-Eleven. ",
    earnYuuPoints: "Earn yuu points",
    cantEarnYuuPoints: "Cannot earn yuu Point as you spend ",
    collect7EleventAndYuuStamp: "Collect 7-Eleven and yuu Stamps",
    cannotCollect7EleventAndYuuStamp: "Cannot collect 7-Eleven and yuu Stamps",
    continueAsYuuMember: "Continue as yuu Member",
    continueWithYuu: "Link yuu Account",
    yuuTips2: "Once you tap ‘Continue with yuu’, your personal information  will pass to 7-Eleven.",
    yuuTips3: "(*including phone number, email address, name, date of birth and yuu ID)",
    limitedFunctions: "The following functions are inapplicable if skip linking your yuu account:​",
    next: "Next",
    selectARegion: "Select a region",
    hongKong: "+852 Hong Kong SAR",
    macau: "+853 Macau SAR",
    china: "+86  China",
    notContinueYuu: "Continue without yuu?",
    notContinueYuuContent: "You will not be able to earn Points as you spend and collect Stamps. ",
    letMeThink: "Let me think",
    skipYuu: "Skip yuu",
    resend: "Resend",
    phoneNumberMismatch: "Please ensure the registeration mobile number is the same as yuu registered mobile number.",
    yuuIdBoundToAnotherPhoneNumber:
      "The yuu account has already been linked to another phone number.Please contact customer service for assistance.",
    phoneNumberLocked: "The yuu account has been locked, Please contact customer service for assistance.",
    failedRegistration: "Sign up Failed",
    failedToLinkYuuId: "Failed to link yuu ID",
    linkYuuID: "Link yuu Account",
    gotIt: "Got it"
  },
  address: {
    addNewAddress: "Add new address",
    confirm: "Confirm",
    pleaseNoteQuantityAndPromotions:
      "Please note that the quantity and promotions may vary based on your chosen delivery method.",
    edit: "Edit",
    cancel: "Cancel",
    yes: "Yes",
    remove: "Remove",
    default: "Default address",
    defaultAddressTips: "This will be your default address automatically",
    mandatoryFields: "Required",
    address: "Address",
    floorAndUnit: "Floor & Unit",
    buildingAndEstate: "Building & Estate",
    addressLabel: "Address Label",
    selectDeliveryAddress: "Select delivery address",
    addAddress: "Add address",
    pleaseFillYourAddressHere: "Please fill your address here",
    EgUnit606: "E.g. Room 601",
    pleaseFill: "Optional",
    enterAddressLabel: "Enter Address Label",
    editAddress: "Edit address",
    removeThisAddress: "Remove this address?",
    actionCannotUndone: "This action cannot be undone.",
    keepAddress: "Keep address",
    addressRemoved: "Address Removed",
    home: "Home",
    work: "Work",
    other: "Other",
    office: "Office",
    makeThisMyDefaultAddress: "Make this my default address",
    noData: "no Data",
    leavePageTipsTile: "Are you sure you want to leave this page?",
    leavePageTips: "If you leave this page, any changes you have made will be lost.",
    returnToSite: "Return to site",
    continueEdit: "Continue editing",
    freeAndFastDelivery: "Free & fast delivery!",
    addressAdded: "Successfully saved",
    addressUpdated: "Address has been updated",
    loadingText: "Loading",
    userName: "Name",
    phone: "Phone Number",
    pleaseEnterName: "Please enter name",
    pleaseEnterPhoneNumber: "Please enter phone number",
    empty: "You don’t have any delivery address",
    save: "Save",
    placeholderAddress: "Please select the delivery address",
    searchAddress: "Search Address",
    unitDetails: "Floor & Unit No.",
    addLabel: "Add Label",
    unitDetailsPlaceholder: "E.g:Room 301, Building 6",
    outsideOfDeliveryArea: "This address is outside of delivery area.",
    searchAddressPlaceholder: "Enter address/ building",
    removeTips: "Confirm removal of this address?",
    removeError: "Unable to delete current delivery address",
    editTips: "Discard address edits?",
    notarize: "Confirm"
  },
  deliveryMethod: {
    title: "Delivery method",
    homeDelivery: "Home delivery",
    delivery: "Delivery",
    Pickup: "Pickup",
    clickCollect: "Click & collect",
    clickCollectTip: "Save more delivery fee!",
    deliveryOnly: "Delivery",
    lowerDeliveryFee: "Free click & collect service upon low min. spend!",
    nonDeliveryDesc: "on orders over HK${amount}",
    selectPickupStore: "Select store for pick-up",
    provincial: "Region",
    district: "District",
    area: "Area",
    selectRegion: "Please select region",
    selectMunicipal: "Please select district",

    storeDisabledDesc: "Storage full, please try another day.",
    clickCollectNotice: "Please note that the quantity and promotions may vary based on your chosen delivery method.",
    confirm: "Confirm",
    pleaseSelect: "Please select",
    emptyText: "No data",
    stayTunedDesc: "More stores coming soon! Stay tuned!",
    selectAstore: "Select a store",
    reset: "Reset",
    searchResult: "Search result",
    noResultFor: 'No result for "{keyword}"',
    enterKeywords: "Please enter another keywords",
    noStorePopTitle: "Select your pickup store",
    noStorePopContent: "Please select your pickup store, so we can offer you the best shopping experience"
  },
  storeLocator: {
    fullMapView: "Full Map View",
    showListVew: "Show List View",
    title: "Store Locator",
    region: "Region",
    district: "District",
    service: "Service",
    listView: "List View",
    mapView: "Map View",
    getDirections: "Get Directions",
    enterAddressOrBuilding: "Enter address/building",
    openingHours: "Opening Hours",
    nearestStore: "Nearest Store",
    locationError: "Google Maps could not determine your precise location.",
    photo: "Photo"
  },
  notification: {
    appPushNotification: "App Push Notification",
    appTips: "Receive latest promotion update",
    smsNotification: "SMS",
    smsTips: "Get notified by SMS for the latest promotion",
    emailNotification: "Email Notification",
    emailTips: "Get notified by email for the latest promotion",
    operationSuccessful: "Operation Successful",
    operationFailed: "Operation Failed",
    title: "Notification",
    viewAll: "View All",
    emptyText: "No message at the moment",
    noMoreText: "Show only the messages from the past three months.",
    learnMore: "Learn more",
    details: "Details",
    markAllAsRead: "Mark all as read!"
  },
  profile: {
    personalInformation: "Personal Information",
    name: "Name",
    namePlaceholder: "Please enter your name",
    email: "Email",
    emailPlaceholder: "Please enter your email",
    DateOfBirth: "Date of Birth",
    DateOfBirthPlaceholder: "MM/DD/YYYY",
    birthTips: "Once the date of birth is confirmed, it cannot be modified. Please enter carefully.",
    update: "Update",
    enjoyPersonalisedExperience: "Enjoy personalised experience",
    letUsKnow: "Let us know more about you"
  },
  linkYuu: {
    id: "yuu ID:",
    title: "Link yuu ID",
    enterYourYuuId: "Enter your yuu ID",
    linkNotice: "Have a yuu ID? Link your yuu account now to earn yuu points!",
    unlinkNotice: "Are you sure you want to unlink your yuu ID for this account?",
    cancel: "Cancel",
    unlink: "Unlink",
    textWith11Digits: "Please enter an 8-digit yuu ID number",
    desc: "Link yuu ID to enjoy the full benefits of 7-Eleven and yuu."
  },
  productLabel: {
    HK_EXC: "HK",
    MO_EXC: "MO"
  },
  sku: {
    normal: "Normal",
    soldOut: "Unavailable",
    takeDown: "Unavailable",
    blacklist: "Unavailable",
    commingSoon: "Coming Soon",
    findSimilar: "Similar products",
    outOfStock: "Unavailiable",
    add: "Add to cart",
    quantity: "Quantity",
    update: "Update",
    select: "Selections",
    buyNumLabel: "Quantity",
    customizationTitle: "Personalized customization"
  },
  login: {
    title: "This website is not supported in your region.Please download and use the mobile app instead.",
    downloadApp: "Download App"
  },
  customContent: {
    title: "Custom content",
    default: "Default",
    placeholder: "Please enter your customized content."
  }
}
